//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MoominLink from "~/themes/fiskarsMoominDefault/components/components/atoms/MoominLink/MoominLink.vue";
import SfButton from "../../../atoms/SfButton/SfButton";
import SfMenuItem from "../../../molecules/SfMenuItem/SfMenuItem";

export default {
  name: "SfHeaderNavigationItem",
  components: {
    SfButton,
    MoominLink,
    SfMenuItem,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
    link: {
      type: [String, Object],
      default: "",
    },
  },
};
